const api = "https://api.alphaar.io/resources/";
//const api = "http://192.168.1.8:8080/resources/";

export function getResource(resourceId) {
  return fetch(api + resourceId).then((data) => data.json());
}

export function createRedirectQR(redirectURL) {
  return fetch(
    "https://chart.googleapis.com/chart?chs=150x150&cht=qr&chl=" +
      redirectURL +
      "&choe=UTF-8",
    {
      method: "POST",
    }
  ).then((data) => data);
}
